import isObject from 'lodash/isObject';

import type { AxiosBaseQueryError } from 'store/types';

export function isAxiosBaseQueryError(error: unknown): error is AxiosBaseQueryError {
  return isObject(error) && 'message' in error && 'status' in error;
}
